// Display order of the landing page cards (furniture, tag 18, is intentionally
// excluded). `slug` is the /design-ideas/[category] route each card links to.
const DEV_TAG_IDS = {
  bedroom: 1,
  "living-room": 7,
  kitchen: 5,
  wardrobe: 9,
  bathroom: 3,
  "dining-room": 4,
  storage: 19,
  balcony: 2,
  "false-ceiling": 20,
  "kids-room": 15,
  "tv-unit": 11,
  "pooja-unit": 10,
  "entrance-foyer": 6,
  door: 16,
  staircase: 14,
  commercial: 13,
};

const PROD_TAG_IDS = {
  bedroom: 2,
  "living-room": 7,
  kitchen: 6,
  wardrobe: 12,
  bathroom: 3,
  "dining-room": 4,
  storage: 22,
  balcony: 1,
  "false-ceiling": 16,
  "kids-room": 18,
  "tv-unit": 14,
  "pooja-unit": 11,
  "entrance-foyer": 5,
  door: 19,
  staircase: 17,
  commercial: 13,
};

// Only prod differs; dev, stage and local share the dev IDs.
const isProd = (process.env.NEXT_PUBLIC_ENV || "").toLowerCase() === "prod";
const TAG_IDS = isProd ? PROD_TAG_IDS : DEV_TAG_IDS;

export const DESIGN_IDEA_TAGS = Object.keys(DEV_TAG_IDS).map((slug) => ({
  tagId: TAG_IDS[slug],
  slug,
}));

// Cards 1-4 are single-image, 5-10 are trio cards, the rest are stacked cards.
export const SINGLE_CARD_COUNT = 4;
export const TRIO_CARD_COUNT = 6;
